import { clx, ControlledInput, ControlledInputProps } from "@hm/fundamental"
import { forwardRef, useState } from "react"
import { useFormContext } from "react-hook-form"

const LABEL_TOP_CLASSNAME =
	"[&>div>div>div]:font-normal [&>div>div>div]:text-12px [&>div>div>div]:leading-16px [&>div>div>div]:top-0 [&>div>div>div]:mt-4px"

export const BaseControlledInput = forwardRef<
	HTMLInputElement,
	ControlledInputProps
>(({ label, name, placeholder, className, onFocus, onBlur, ...props }, ref) => {
	const [isFocus, setIsFocus] = useState(false)

	const { getValues } = useFormContext()

	const labelOnly = label && name && !getValues(name) && !isFocus
	const placeholderOnly = placeholder && isFocus

	return (
		<ControlledInput
			ref={ref}
			className={clx(className, !labelOnly && LABEL_TOP_CLASSNAME)}
			name={name}
			label={label}
			placeholder={placeholderOnly ? placeholder : ""}
			onFocus={e => {
				setIsFocus(true)
				onFocus?.(e)
			}}
			onBlur={e => {
				setIsFocus(false)
				onBlur?.(e)
			}}
			{...props}
		/>
	)
})
